import { Dispatch } from 'react'
import Modal from 'react-modal'
import { useDispatch } from 'react-redux'
import { ModalCloseButton } from 'src/components/global/ModalCloseButton'
import { useClaimVendorListingMutation } from 'src/graphql/generated/hooks'
import { showToast } from 'src/store/actions/toastAction'

interface ClaimYourListingModalProps {
  vendorName: string
  solutionName: string
  userEmail: string
  isOpen: boolean
  onClose?: () => void
}

const ModalStyles: Modal.Styles = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: '99',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderWidth: '0px',
    backgroundColor: 'transparent',
    border: '0px solid red',
    zIndex: '99',
  },
}

export const ClaimYourListingModal: React.FC<ClaimYourListingModalProps> = ({
  isOpen,
  onClose,
  vendorName,
  solutionName,
  userEmail,
}) => {
  const [claimVendorListing] = useClaimVendorListingMutation()
  const dispatch: Dispatch<any> = useDispatch()

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const handleContactLTH = async () => {
    try {
      const res = await claimVendorListing({
        variables: {
          data: {
            name: vendorName,
            userEmail: userEmail,
            solutionName: solutionName,
          },
        },
      })
      if (res) {
        dispatch(
          showToast(
            'Your claim request has been submitted. Our team will be notified of your request and will verify your account shortly.',
            'success',
          ),
        )
        handleClose()
      }
    } catch (error) {
      dispatch(showToast('An error occurred while sending email.', 'error'))
    }
  }

  return (
    <Modal
      closeTimeoutMS={200}
      isOpen={isOpen}
      onRequestClose={handleClose}
      style={ModalStyles}
      ariaHideApp={false}
      shouldCloseOnEsc={true}
    >
      <div className="flex justify-center items-center">
        <div className="flex flex-col md:w-[600px] w-full md:pl-0 md:pr-0 pl-[30px] pr-[30px]">
          <div className="flex flex-row w-full" style={{ zIndex: '10' }}>
            <ModalCloseButton onClose={handleClose} />
          </div>
          <div className="flex flex-col overflow-hidden mr-[15px] mt-[-20px]">
            <div className="request-contact-container flex flex-col w-full md:pl-[60px] md:pr-[60px] pl-[20px] pr-[20px]">
              <div className="flex flex-col w-full pb-6">
                <div className="h-[1px] bg-[#DDDDDD]"></div>

                <p className="flex items-center min-h-[81px] md:h-full text-[18px] font-bold font-secondary text-darkgray mt-11 text-center">
                  If you manage this solution at {vendorName}, please contact the LTH team to associate it with your
                  account.
                </p>

                <div className="flex justify-center w-full py-6">
                  <button
                    className="px-7 h-[50px] rounded-full bg-[#011d58] grow-2 w-[200px] font-semibold text-[14px]"
                    type="submit"
                    onClick={handleContactLTH}
                  >
                    <p className="text-white">Contact LTH Team</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
